export type ScoreBand = "high" | "mid" | "low"

export const scoreBand = (pct: number): ScoreBand => {
  if (pct >= 70) return "high"
  if (pct >= 50) return "mid"
  return "low"
}
